var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_20_1",
    "data-name": "Component 20 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 328.719,
    height: 328.72,
    viewBox: "0 0 328.719 328.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18565",
    "data-name": "Group 18565",
    transform: "translate(-4873.466 7185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18565-2",
    "data-name": "Group 18565",
    transform: "translate(4841 -7185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17860",
    "data-name": "Group 17860",
    transform: "translate(32.466 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3272",
    "data-name": "Group 3272",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M165.36,329.72A164.36,164.36,0,1,1,329.72,165.36,164.36,164.36,0,0,1,165.36,329.72Zm0-29.884A134.476,134.476,0,1,0,30.884,165.36,134.476,134.476,0,0,0,165.36,299.836Z",
    transform: "translate(-1 -1)",
    fill: "#177aad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3273",
    "data-name": "Group 3273",
    transform: "translate(111.328 111.406)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x1: 106.474,
    y2: 105.376,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#177aad",
    strokeLinecap: "round",
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    x2: 106.474,
    y2: 105.376,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#177aad",
    strokeLinecap: "round",
    strokeWidth: 14
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.0092fac48d7472aa3bdb7bd139d9e547.svg";
export { ForwardRef as ReactComponent };